import React, {useState} from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import {
    constance,
} from '../../../common/constance/constance';
import {common} from '../../../common/common';
import {styles} from '../../../common/style';
import {useNavigate} from 'react-router-dom';
import {MenuInterface} from "../../../interface/menu.interface";
import {Book} from "../../../interface/book.interface";
import {Grid, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import Button from "@mui/material/Button";
import axios from "axios";
import {useSelector} from "react-redux";
import {RootState} from "../../../reducer";
import {isMobile} from "react-device-detect";
import Box from "@mui/material/Box";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ApplyBookRentalDialog from "../../dialog/ApplyBookRentalDialog";
import OneLineReviewListDialog from "../../dialog/OneLineReviewListDialog";

export default function BookRentalListTable(props: { bookList: Book[], menu: MenuInterface, getList: any, state: any, setState: any }) {
    console.log('[BookRentalListTable]');
    const navigate = useNavigate();
    const commonData = useSelector((state: RootState) => state.commonData);
    let {id, workplace, no} = common.getQuery();

    const [openDialog, setOpenDialog] = useState(false);
    const [state, setState] = useState({
        bookId: '',
        isReturn: false,
        openDialog: false,
        openReviewDialog: false,
        reviews: []
    })

    function openBookRentalDialog(book: Book, isReturn: boolean) {
        setState({
            ...state,
            bookId: book._id,
            isReturn: isReturn,
            openDialog: true
        })
    }

    function openReviewDialog(book: Book) {
        let list = book.reviews ? book.reviews : [];
        setState({
            ...state,
            openReviewDialog: true,
            reviews: list
        })
    }

    /* 도서 대여 신청 */
    function application(oneLineReview: string) {
        axios.post(constance.api.applyBookRental, {
            params: {
                _id: state.bookId,
                isReturn: state.isReturn,
                oneLineReview: oneLineReview,
            },
        }).then(value => {
            if (value.data.result) {
                common.alert('', value.data.message, 'info');
                props.getList();
            } else {
                common.alert('도서대여 실패', value.data.message, 'info');
            }
        })
    }

    function getButtonText(book: Book) {
        let buttonText = '대여하기';
        let isReturn = false;
        if (commonData.user && book.lender) {
            if (commonData.user._id == book.lender._id) {
                buttonText = '반납하기';
                isReturn = true;
            }
        }
        return {buttonText, isReturn};
    }

    function handleChangeSort(sort: string) {
        props.setState({
            ...props.state,
            sort: sort,
            sortValue: {
                ...props.state.sortValue,
                [sort]: props.state.sortValue[sort] == 1 ? -1 : 1
            }
        })
    }

    let fontSize: any = isMobile ? "subtitle2" : "subtitle1";

    return (
        <>
            {
                isMobile ?
                    <Stack>
                        {
                            props.bookList.map((book, index) => {
                                let {buttonText, isReturn} = getButtonText(book);

                                return <Stack key={index} sx={{mb: 2}}>
                                    <Grid container
                                        // rowSpacing={1}
                                          component={Paper}
                                          sx={{p: 0}}>
                                        <Grid item xs={12}
                                              sx={{display: 'flex', width: 1, background: '#a91c1c', p: 1}}>
                                            <Typography align="center" variant={fontSize} sx={{color: '#fff'}}>
                                                {`[${constance.workplaceNameMap[book.workplace]}] ${book.name}`}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} sx={{display: 'flex', p: 1, borderBottom: styles.border}}>
                                            <Typography align="left" sx={{width: 0.3}} variant={fontSize}>
                                                {"저자"}
                                            </Typography>
                                            <Typography align="center" sx={{width: 0.7}} variant={fontSize}>
                                                {book.author}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} sx={{display: 'flex', p: 1, borderBottom: styles.border}}>
                                            <Typography align="left" sx={{width: 0.3}}>
                                                {"출판사"}
                                            </Typography>
                                            <Typography align="center" sx={{width: 0.7}} variant={fontSize}>
                                                {book.publisher}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} sx={{display: 'flex', p: 1, borderBottom: styles.border}}>
                                            <Typography align="left" sx={{width: 0.3}} variant={fontSize}>
                                                {"상태"}
                                            </Typography>
                                            <Typography align="center" sx={{width: 0.7, ...styles.textKeepAll}}
                                                        variant={fontSize}>
                                                {
                                                    book.lender != null ?
                                                        `${book.lender.departmentName} ${book.lender.name} 대여 중` : '대여 가능'
                                                }
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} sx={{display: 'flex', p: 1, borderBottom: styles.border}}>
                                            <Typography align="left" sx={{width: 0.3}} variant={fontSize}>
                                                {"반납기한"}
                                            </Typography>
                                            <Typography align="center" sx={{width: 0.7}} variant={fontSize}>
                                                {
                                                    book.lender != null ? common.getTimeFormatYMD(book.returnDate) : '-'
                                                }
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Box sx={{display: 'flex', width: 1, justifyContent: 'flex-end', p: 1}}>
                                        <Button variant={"contained"}
                                                disabled={book.lender != null && !isReturn}
                                                color={book.lender != null ? 'info' : 'error'}
                                            // sx={{backgroundColor: book.lender != null ? '' : 'red'}}
                                                onClick={() => openBookRentalDialog(book, isReturn)}>
                                            <Typography variant={fontSize}>
                                                {buttonText}
                                            </Typography>
                                        </Button>
                                    </Box>
                                </Stack>
                            })
                        }
                    </Stack>
                    :
                    <TableContainer component={Paper}>
                        <Table sx={{minWidth: 300}} size={'medium'} aria-label="a dense table">
                            <TableHead>
                                <TableRow sx={{'th': {padding: '16px'}, width: 1, height: 65}}>
                                    <TableCell align="center"
                                               sx={{display: {xs: 'none', sm: 'none', md: 'table-cell'}}}>
                                        <Typography variant={fontSize}>번호</Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography variant={fontSize}>사업장</Typography>
                                    </TableCell>
                                    <TableCell onClick={() => handleChangeSort('name')}
                                               align="center"
                                               sx={{
                                                   cursor: 'pointer',
                                                   color: props.state.sort == 'name' ? '#E00000FF' : 'inherit'
                                               }}>
                                        <Box sx={{display: 'flex', width: 1, justifyContent: 'center'}}>
                                            <Typography variant={fontSize}>도서명</Typography>
                                            {
                                                props.state.sortValue['name'] == 1 ?
                                                    <ArrowDropUpIcon/> :
                                                    <ArrowDropDownIcon/>
                                            }
                                        </Box>
                                    </TableCell>
                                    <TableCell onClick={() => handleChangeSort('author')}
                                               align="center"
                                               sx={{
                                                   cursor: 'pointer',
                                                   color: props.state.sort == 'author' ? '#c00000' : 'inherit'
                                               }}>
                                        <Box sx={{display: 'flex', width: 1, justifyContent: 'center'}}>
                                            <Typography variant={fontSize}>저자</Typography>
                                            {
                                                props.state.sortValue['author'] == 1 ?
                                                    <ArrowDropUpIcon/> :
                                                    <ArrowDropDownIcon/>
                                            }
                                        </Box>
                                    </TableCell>
                                    <TableCell onClick={() => handleChangeSort('publisher')}
                                               align="center"
                                               sx={{
                                                   cursor: 'pointer',
                                                   color: props.state.sort == 'publisher' ? '#c00000' : 'inherit'
                                               }}>
                                        <Box sx={{display: 'flex', width: 1, justifyContent: 'center'}}>
                                            <Typography variant={fontSize}>출판사</Typography>
                                            {
                                                props.state.sortValue['publisher'] == 1 ?
                                                    <ArrowDropUpIcon/> :
                                                    <ArrowDropDownIcon/>
                                            }
                                        </Box>
                                    </TableCell>
                                    <TableCell onClick={() => handleChangeSort('lender')}
                                               align="center"
                                               sx={{
                                                   cursor: 'pointer',
                                                   color: props.state.sort == 'lender' ? '#c00000' : 'inherit'
                                               }}>
                                        <Box sx={{display: 'flex', width: 1, justifyContent: 'center'}}>
                                            <Typography variant={fontSize}>상태</Typography>
                                            {
                                                props.state.sortValue['lender'] == 1 ?
                                                    <ArrowDropUpIcon/> :
                                                    <ArrowDropDownIcon/>
                                            }
                                        </Box>
                                    </TableCell>
                                    <TableCell align="center"><Typography
                                        variant={fontSize}>반납기한</Typography></TableCell>
                                    <TableCell align="center"><Typography
                                        variant={fontSize}>한줄평</Typography></TableCell>
                                    <TableCell align="center"><Typography variant={fontSize}>대여</Typography></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.bookList.map((book, index) => {

                                    let {buttonText, isReturn} = getButtonText(book);

                                    return <TableRow key={index}
                                                     sx={{
                                                         width: 1,
                                                         '&:last-child td, &:last-child th': {border: 0},
                                                         'td': {padding: '8px'},
                                                         ':hover': {
                                                             background: styles.tableHoverColor,
                                                         },
                                                         transition: styles.transition,
                                                     }}
                                    >
                                        {/* 게시글 번호 */}
                                        <TableCell align="center" sx={{width: 0.1}}>
                                            <Typography variant={fontSize}> {book.no} </Typography>
                                        </TableCell>

                                        {/* 사업장 */}
                                        <TableCell align="center" sx={{width: 0.1}}>
                                            <Typography
                                                variant={fontSize}> {constance.workplaceNameMap[book.workplace]}  </Typography>
                                        </TableCell>

                                        {/* 제목 */}
                                        <TableCell align="center" sx={{width: 0.2}}>
                                            <Typography variant={fontSize} sx={{...styles.textKeepAll}}>
                                                {book.name}
                                            </Typography>
                                        </TableCell>

                                        {/* 저자 */}
                                        <TableCell align="center" sx={{width: 0.2}}>
                                            <Typography variant={fontSize} sx={{width: 1, ...styles.textKeepAll}}>
                                                {book.author}
                                            </Typography>
                                        </TableCell>

                                        {/* 출판사 */}
                                        <TableCell align="center" sx={{width: 0.1}}>
                                            <Typography variant={fontSize}
                                                        sx={{...styles.textHidden}}>{book.publisher}</Typography>
                                        </TableCell>

                                        {/* 상태 */}
                                        <TableCell align="center" sx={{width: 0.1}}>
                                            <Typography variant={fontSize} sx={{...styles.textKeepAll}}>
                                                {
                                                    book.lender != null ?
                                                        `${book.lender.departmentName} ${book.lender.name} 대여 중` : '대여 가능'
                                                }
                                            </Typography>
                                        </TableCell>

                                        {/* 반납기한 */}
                                        <TableCell align="center" sx={{width: 0.1}}>
                                            <Typography variant={fontSize}>
                                                {
                                                    book.lender != null ? common.getTimeFormatYMD(book.returnDate) : '-'
                                                }
                                            </Typography>
                                        </TableCell>

                                        {/* 한줄평 */}
                                        <TableCell align="center" sx={{width: 0.1}}>
                                            <Button variant={"text"}
                                                    color={'error'}
                                                    disabled={book.reviews.length == 0}
                                                    onClick={() => openReviewDialog(book)}>
                                                <Stack>
                                                    {
                                                        book.reviews.length > 0 ? <>
                                                                <Typography variant={fontSize}>
                                                                    {book.reviews.length} 개
                                                                </Typography>
                                                                <Typography variant={fontSize}>
                                                                    확인하기
                                                                </Typography>
                                                            </>
                                                            : "-"
                                                    }

                                                </Stack>
                                            </Button>
                                        </TableCell>

                                        {/* 대여버튼 */}
                                        <TableCell align="center" sx={{width: 0.1}}>
                                            <Button variant={"contained"}
                                                    disabled={book.lender != null && !isReturn}
                                                    color={book.lender != null ? 'info' : 'error'}
                                                // sx={{backgroundColor: book.lender != null ? '' : 'red'}}
                                                    onClick={() => openBookRentalDialog(book, isReturn)}>
                                                <Typography variant={fontSize}>
                                                    {buttonText}
                                                </Typography>
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                })}

                            </TableBody>
                        </Table>
                    </TableContainer>
            }

            <ApplyBookRentalDialog state={state} setState={setState} application={application}/>
            <OneLineReviewListDialog state={state} setState={setState}/>
        </>


    );
}
